import { PureComponent } from 'react'
import PropTypes from 'meta/PropTypes'
import { Box, Flex, Layout } from 'react-flex-lite'

import LinkButton from 'components/interactive/LinkButton'
import cn from 'classnames'
import './index.scss'

@Layout
export default class MarketingFooter extends PureComponent {
  static propTypes = {
    className: PropTypes.string
  }
  render = () => {
    const { className, ...rest } = this.props
    return <Flex
      wrap justify="space-between" align="center"
      className={cn('marketing-footer-component', className)}
      {...rest}>
      <Flex auto column wrap className="links">
        <LinkButton plain external to="https://stae.co/terms" text="Terms" />
        <LinkButton plain external to="https://stae.co/privacy" text="Privacy" />
        <LinkButton plain external to="https://stae.co/about" text="About" />
        <LinkButton plain external to="https://medium.com/city-as-a-service" text="Blog" />
        <LinkButton plain external to="https://support.municipal.systems" text="Guides" />
      </Flex>
      <Flex auto column className="company-info">
        <Box className="tagline">Symbiotic technology and ecology</Box>
        <Box className="company-name">Stae Inc.</Box>
      </Flex>
    </Flex>
  }
}
